import { List } from 'immutable';

export default class Hydrator {
  static assign(obj, mapProperties = {}, keyTransformer = {}) {
    return (instance, key) => {
      const transformedKey = keyTransformer[key] !== undefined ? keyTransformer[key] : key;
      const mappedValue =
        mapProperties[key] !== undefined ? mapProperties[key](obj[key]) : obj[key];

      // eslint-disable-next-line no-param-reassign
      instance[transformedKey] = mappedValue;
      return instance;
    };
  }

  static timestamp2Date(timestamp) {
    if (typeof !timestamp === 'undefined' || timestamp === null) {
      return timestamp;
    }

    if (typeof timestamp === 'number') {
      return new Date(timestamp * 1000);
    }

    return new Date(timestamp);
  }

  static date2Timestamp(date) {
    if (!(date instanceof Date)) {
      return date;
    }

    return date.getTime() / 1000;
  }

  static toFloat(value = 0.0) {
    if (typeof value === 'number') {
      return value;
    }

    return parseFloat(value);
  }

  static toInt(value = 0) {
    if (typeof value === 'number') {
      return value;
    }

    return parseInt(value, 10);
  }

  static fromArray(func) {
    return (arr) => (arr || []).map((e) => func(e));
  }

  static fromList(func) {
    return (arr = List()) => List(arr).map((e) => func(e));
  }

  static toImmutableList() {
    return (arr = []) => List(arr);
  }
}
